module.exports = __webpack_public_path__ + "static/media/expenseclaim-on.117a7b38.svg";